import './template_chooser_controller';

angular
  .module('app.views')
  .config(function (tagsInputConfigProvider) {
    tagsInputConfigProvider.setDefaults('tagsInput', { placeholder: '' });
  })
  .controller('UpgradeFormController', function ($scope, $modalInstance, Boxcaster, Upgrade, $routeParams, User, $modal, isRma, dealId, pandadocToken) {
    let boxcasters = [];
    Boxcaster.query({"filter.account_id": $routeParams.id}).$promise.then((b) => {
      boxcasters = b.map(b => b.id);
    });

    User.query({ account_id: $routeParams.id, 'filter.include_archived': 'false', l: 50 }).$promise.then((res) => {
        $scope.users = res;
        $scope.recipient = $scope.users[0];
    });

    // These map to HS Deal property values: https://app.hubspot.com/property-settings/484866/deal/rma_customer_expectation
    $scope.CUSTOMER_EXPECTATION_VALUES = [
      'Replacement Order Entered',
      'No Replacement Needed',
      'Repair and Return',
      '30 Day Money Back Guarantee',
    ];
    $scope.DEFAULT_CUSTOMER_EXPECTATION = 'Replacement Order Entered';

    // These map to HS Deal property values: https://app.hubspot.com/property-settings/484866/deal/rma_product_type
    $scope.PRODUCT_TYPE_VALUES = [
      'BoxCaster',
      'BoxCaster Pro',
      'Wired Scoreboard Adapter',
      'Wireless Scoreboard Adapter',
      'Magewell Rental Encoder',
      'LiveShell X Rental Encoder',
      'LiveShell Pro Rental Encoder',
      'LiveShell 2 Rental Encoder',
      'Scoreboard Assist',
    ]
    $scope.DEFAULT_PRODUCT_TYPE = 'BoxCaster';

    $scope.template = null;
    $scope.isRma = isRma;
    $scope.dealId = dealId;
    $scope.pandadocToken = pandadocToken;
    $scope.generateProposal = true;
    $scope.isCreating = false;
    $scope.customerExpectation = $scope.DEFAULT_CUSTOMER_EXPECTATION;
    $scope.productType = $scope.DEFAULT_PRODUCT_TYPE;
    $scope.serialNumber = null;
    $scope.summary = null;
    $scope.supportLink = null;

    $scope.loadBoxcasters = function (query) {
      return boxcasters.filter(b => {
        return b.indexOf(query) > -1;
      });
    }

    $scope.onSelectTemplate = function () {
      $modal.open({
        template: require('./template_chooser.html'),
        controller: 'TemplateChooserController',
        size: 'md',
        backdrop: 'static',
      }).result.then(template => $scope.template = template);
    }

    $scope.ok = function () {
      if (!$scope.isRma && !$scope.template && !!$scope.dealId) {
        // Nothing to do - the deal already exists and no proposal template was selected
        $modalInstance.close({dealid: $scope.dealId});
        return;
      }

      $scope.submit();
    };

    $scope.submit = function () {
      $scope.isCreating = true;
      Upgrade.create({
        account_id: $routeParams.id,
        rma_customer_expectation: $scope.isRma ? $scope.customerExpectation : null,
        rma_product_type: $scope.isRma ? $scope.productType : null,
        rma_serial_number: $scope.isRma ? $scope.serialNumber.pop().text : null,
        rma_summary: $scope.summary,
        rma_support_link: $scope.supportLink,
        pandadoc_template_id: ($scope.template||{}).id,
        recipient_email: $scope.recipient.email,
        hubspot_deal_id: $scope.dealId,
        pandadoc_access_token: $scope.pandadocToken,
      }).$promise.then(u => {
        $modalInstance.close(u)
      }).catch((err) => {
        console.error(err);
        alert('Error creating RMA deal');
      }).finally(() => {
        $scope.isCreating = false;
      });
    }

    $scope.isValid = function () {
      if ($scope.isRma && !$scope.form.$valid) {
        return false;
      }
      if ($scope.generateProposal && !$scope.template) {
        return false;
      }
      return true;
    }

    return $scope.cancel = () => $modalInstance.dismiss('cancel');
  });



// WEBPACK FOOTER //
// ./views/upgrade/upgrade_form_controller.js